import React from "react";

import {Wrapper} from "./EmptySlotCell.styles";
export const EmptySlotCell = ({
    content = "-",
    hoverContent = "-",
    disabled = false,
    mode = "normal",
    hover = true,
    children
}) => {
    if (children !== undefined) {
        return <Wrapper disabled={disabled}>{children}</Wrapper>;
    }

    return (
        <Wrapper
            disabled={disabled}
            mode={mode}
            hover={hover}
            content={content}
            hoverContent={hoverContent}
        ></Wrapper>
    );
};
